import {Observable, of, Subject} from 'rxjs';
import {retry} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {CustomRegion, CustomRegionRecord} from '../symbols/scan-viewer.symbols';


@Injectable()
export class CustomRegionEditService {
  constructor(private http: HttpClient) {
  }

  private deleteRegionSubject$ = new Subject<CustomRegion>();
  private editRegionTextSubject$ = new Subject<CustomRegion>();
  private drawModeSubject$ = new Subject<boolean>();
  private focusRegionSubject$ = new Subject<CustomRegion>();
  private newRegionSubject$ = new Subject<void>();
  private showRegionCardSubject$ = new Subject<void>();

  static buildRegionRecordDetailURL(submissionId: string, name: string) {
    return `/api/research/scan/region-record/${submissionId}/${name}`;
    // return `/api/region-record/${submissionId}/${name}`;
  }

  static buildRegionRecordListURL(submissionId: string) {
    return `/api/research/scan/region-records/${submissionId}`;
    // return `/api/region-records/${submissionId}`;
  }

  deleteRegion(region: CustomRegion) {
    this.deleteRegionSubject$.next(region);
  }

  deleteRegionObservable(): Observable<CustomRegion> {
    return this.deleteRegionSubject$.asObservable();
  }

  editRegionText(region: CustomRegion) {
    this.editRegionTextSubject$.next(region);
  }

  editRegionTextObservable(): Observable<CustomRegion> {
    return this.editRegionTextSubject$.asObservable();
  }

  changeDrawMode(mode: boolean) {
    this.drawModeSubject$.next(mode);
  }

  drawModeChangedObservable(): Observable<boolean> {
    return this.drawModeSubject$.asObservable();
  }

  focusRegion(region: CustomRegion) {
    this.focusRegionSubject$.next(region);
  }

  focusRegionObservable(): Observable<CustomRegion> {
    return this.focusRegionSubject$.asObservable();
  }

  newRegion() {
    this.newRegionSubject$.next();
  }

  newRegionObservable(): Observable<void> {
    return this.newRegionSubject$.asObservable();
  }

  showRegionCard() {
    this.showRegionCardSubject$.next();
  }

  showRegionCardObservable(): Observable<void> {
    return this.showRegionCardSubject$.asObservable();
  }

  listRecords(submissionId: string): Observable<CustomRegionRecord[]> {
    const url = CustomRegionEditService.buildRegionRecordListURL(submissionId);

    return this.http.get<CustomRegionRecord[]>(url).pipe(retry(3));
  }

  loadRecord(submissionId: string, name: string, isStaticSubmission: boolean = false): Observable<CustomRegionRecord> {
    // Workaround until we start to save labels for static submissions
    if (isStaticSubmission) {
      return of({});
    } else {
      const url = CustomRegionEditService.buildRegionRecordDetailURL(submissionId, name);

      return this.http.get<CustomRegionRecord>(url).pipe(retry(3));
    }
  }

  saveRecord(submissionId: string, name: string, version: number, data: string): Observable<any> {
    const url = CustomRegionEditService.buildRegionRecordDetailURL(submissionId, name);
    const record: CustomRegionRecord = {
      scan: submissionId,
      name,
      version,
      data,
    };

    return this.http.put(url, record);
  }

  deleteRecord(submissionId: string, name: string): Observable<CustomRegionRecord> {
    const url = CustomRegionEditService.buildRegionRecordDetailURL(submissionId, name);

    return this.http.delete<CustomRegionRecord>(url);
  }
}
